module.exports = __webpack_public_path__ + "img/4 - 3 - 2 - 1.5c25624f.jpg";